<template>
  <a-card :bordered="false" :bodyStyle="{ padding: '0px' }">
    <Breadcrumb routeName="HomeInlet" toName="百货频道设置" goPathName="首页快捷入口"></Breadcrumb>
    <a-row style="padding: 10px 20px 0;">
      <detail-list :col="1">
        <detail-list-item term="开启频道">
          <a-radio-group v-model="channelStatus" @change="onChange">
            <a-radio :value="1">开启</a-radio>
            <a-radio :value="0">关闭</a-radio>
          </a-radio-group>
        </detail-list-item>
      </detail-list>
    </a-row>
    <a-row>
      <a-col :span="12">
        <span class="cardly-title">{{ hotTitle }}</span>
      </a-col>
      <!-- <a-col :span="11" class="text-right">
        修改栏目名称或开启自动推荐 &nbsp;&nbsp; <a @click="settingTitle1">设置</a>
      </a-col> -->
    </a-row>
    <!-- 限时 -->
    <HotSaleList></HotSaleList>
    <a-row>
      <a-col :span="12">
        <span class="cardly-title">{{ brandTitle }}</span>
      </a-col>
      <!-- <a-col :span="11" class="text-right"> 修改栏目名称&nbsp;&nbsp; <a @click="settingTitle2">设置</a> </a-col> -->
    </a-row>
    <!-- 品牌 -->
    <BrandSaleList></BrandSaleList>
    <a-modal title="修改栏目名称" :visible="visible1" @ok="handleOk1" @cancel="visible1 = false">
      <a-input v-model="setName1" :maxLength="5" placeholder="请输入"/>
    </a-modal>
    <a-modal title="修改栏目名称" :visible="visible2" @ok="handleOk2" @cancel="visible2 = false">
      <a-input v-model="setName2" :maxLength="5" placeholder="请输入"/>
    </a-modal>
  </a-card>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import HotSaleList from '../component/HotSaleList'
import BrandSaleList from '../component/BrandSaleList'

export default {
  name: 'DepartmentSetting',
  components: {
    Breadcrumb,
    HotSaleList,
    BrandSaleList
  },
  data() {
    return {
      data: [],
      hotTitle: '爆品限时抢',
      setName1: '',
      brandTitle: '品牌专场',
      setName2: '',
      visible1: false,
      visible2: false,
      catalogId: this.$route.query.catalogId,//商品类型
      merchantId: this.$store.getters.userInfo.merchantId,
      channelStatus: 0,
      columns: [
        {
          title: '排序',
          dataIndex: 'index'
        },
        {
          title: '商品ID',
          dataIndex: 'productId'
        },
        {
          title: '封面图片',
          dataIndex: 'picture'
        },
        {
          title: '商品名称',
          dataIndex: 'productName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {
    this.getChannelStatus()
  },
  methods: {
    onChange(e) {
      this.getLogUtils().logWithTag('radio checked', e.target.value)
      let params = new Object()
      params.channelStatus = e.target.value
      params.proType = this.catalogId
      let title = e.target.value == 1 ? '开启' : '关闭'
      this.getHttpServices().getUserService().post('user/merchantInfo/updateChannelStatus', params).then(res => {
        this.$message.success(title + '成功')
        this.channelStatus = e.target.value
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取开启关闭
    getChannelStatus() {
      this.getHttpServices().getUserService().get('user/merchantInfo/getChannelStatus?merchantId=' + this.merchantId + '&proType=' + this.catalogId).then(res => {
        this.channelStatus = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    settingTitle1() {
      this.visible1 = true
    },
    settingTitle2() {
      this.visible2 = true
    },
    handleOk1() {
      this.title1 = this.setName1
      this.visible1 = false
    },
    handleOk2() {
      this.title2 = this.setName2
      this.visible2 = false
    }
  }
}
</script>
<style lang="less" scoped>
.cardly-title {
  margin-left: 25px;
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
  font-size: 15px;
  font-weight: 500;
}

.text-right {
  margin-right: 20px;
  text-align: right;
  font-size: 14px;
  line-height: 32px;
  padding-right: 20px;
}
</style>
